import React from 'react';

function PageLoading() {
    return (
        <div className="loader">Pagina wordt geladen<span className="loader__dot">.</span><span className="loader__dot">.</span><span className="loader__dot">.</span></div>
    )
}

export default PageLoading;